module.exports = __webpack_public_path__ + "static/media/valora-circle.8d462a22.png";